import { useLocation } from 'react-router'
import { Header1 } from '../components/headers/Header1'
import { Header2 } from '../components/headers/Header2'
import { navItems } from '../utils/navItems'



export default function HeaderSection() {
  const location = useLocation()
  const isHome2 = location?.pathname.includes('/home-2')

  if (isHome2) {
    return <Header2 navItems={navItems} />
  } else {
    return <Header1 navItems={navItems} />
  }
}
